import { createSlice } from "@reduxjs/toolkit";

const initialAuthData = {
   data: {}, status: '',
}

const authenticationSlice = createSlice({
    name: 'authentication',
    initialState: initialAuthData,
    reducers:{
        authenticationDetails(state,action) {
            state.data = action.payload;
            state.status = action.status;
        }
    }
});

export const authenticationAction = authenticationSlice.actions;

export default authenticationSlice.reducer;